import "./drawer.js";
import "./main-cabvas.js";
import "../sass/style.scss";

jQuery(document).ready(function ($) {
  objectFitImages();

  /**
   * Init
   */
  var _touch = "ontouchstart" in document ? "touchstart" : "click";
  var locationHref = $(location).attr("href");
  var $topOfWindow = $(window).scrollTop();
  var h = window.innerHeight ? window.innerHeight : $(window).height();

  /**
   * Init render
   */
  if ($topOfWindow > 100) {
    $(".js-header").addClass("is-scrolled");
  }

  /**
   * Remove CharCode
   */
  var spChar = [11, 8203];

  $("body").each(function () {
    var txtBefore = $(this)[0].innerHTML;
    var txtAfter = "";
    for (var i = 0; i < txtBefore.length; i++) {
      var chr = txtBefore.charCodeAt(i);
      if (spChar.indexOf(chr) == -1) {
        txtAfter += String.fromCharCode(chr);
      }
    }
    $(this)[0].innerHTML = txtAfter;
  });

  /**
   * scroll to
   */
  $(".js-scroll").on(_touch, function (e) {
    e.preventDefault();
    $("html,body").animate({ scrollTop: $("#js-info").offset().top });
    return false;
  });

  /**
   * parallax
   */
  var rellax = new Rellax(".rellax");

  /**
   * scroll event
   */

  // 共通の IntersectionObserver を作成する関数
  function createObserver(classToAdd, threshold = 0.2, rootMargin = "0px", childSelectors = null) {
    return new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 子要素のセレクタが指定されている場合
            if (childSelectors) {
              const parent = $(entry.target);
              childSelectors.forEach((selector) => {
                parent.find(selector).each(function () {
                  let timeout = $(this).data("timeout") || 300;
                  setTimeout(() => {
                    let direction = $(this).data("direction");
                    $(this).addClass(`${classToAdd} ${direction || ""}`);
                  }, timeout);
                });
              });
              // 子要素のセレクタが指定されていない場合
            } else {
              let timeout = $(entry.target).data("timeout") || 300;
              setTimeout(() => {
                let direction = $(entry.target).data("direction");
                $(entry.target).addClass(`${classToAdd} ${direction || ""}`);
              }, timeout);
            }
          }
        });
      },
      { threshold, rootMargin },
    );
  }

  // 指定のセレクタに Observer を適用する関数
  function observeElements(observer, selectors) {
    selectors.forEach((selector) => {
      $(selector).each(function () {
        observer.observe(this);
      });
    });
  }

  // 各Observerの定義
  const animObserver = createObserver("animate__animated", 0.1);
  const slideTextObserver = createObserver("is-visible", 0);
  const heroObserver = createObserver("is-animated", 0.1);

  // 監視対象を登録
  observeElements(animObserver, [".js-anim"]);
  observeElements(slideTextObserver, [".js-slide-text", ".js-bg-anim", ".js-slide-text-vertical"]);
  observeElements(heroObserver, [".js-video-anim", ".js-strip-anim"]);

  // ホバーエフェクトを統一
  function addHoverEffect(selector) {
    $(selector).on("mouseenter", function () {
      $(this).addClass("is-hovered").removeClass("is-exiting");
    });

    $(selector).on("mouseleave", function () {
      $(this).removeClass("is-hovered").addClass("is-exiting");
      setTimeout(() => {
        $(this).removeClass("is-exiting");
      }, 400);
    });
  }

  addHoverEffect(".js-card-anim a");

  /**
   * Drawer
   */
  $(".js-drawer").simpleDrawer({
    fixed: true,
    btnside: "right",
    drawerside: "right",
  });

  if ($(".swiper-container").length) {
    var mySwiper = new Swiper(".swiper-container", {
      loop: false,
      effect: "fade",
      speed: 1500,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: true,
      },
    });
  }
  $(".js-pulldown-menu").change(function () {
    if ($(this).val() != "") {
      window.location.href = $(this).val();
    }
  });

  // Swiper の共通初期化関数
  function initializeSwiper(selector, initialSlide = 0, effect = "slide") {
    return new Swiper(selector, {
      slidesPerView: 5,
      spaceBetween: 30,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 1200,
      initialSlide: initialSlide,
      effect: effect,
      breakpoints: {
        980: {
          slidesPerView: 3.2,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2.6,
          spaceBetween: 40,
        },
        580: {
          slidesPerView: 1.9,
          spaceBetween: 40,
        },
        480: {
          slidesPerView: 1.8,
          spaceBetween: 40,
        },
      },
      on: {
        init: function () {
          this.el.classList.add("swiper-initialized");
        },
        slideChangeTransitionStart: function () {
          Object.values(this.slides).forEach((slideEl) => {
            // slideEl が Element 型であることを確認
            if (slideEl instanceof Element) {
              const animatedElement = slideEl.querySelector(".js-slide-text-item");
              if (animatedElement) {
                animatedElement.classList.remove("animated");
              }
            } else {
              console.warn("slideEl is not an Element:", slideEl);
            }
          });

          setTimeout(() => {
            const activeSlide = this.slides[this.activeIndex];
            if (activeSlide && activeSlide instanceof Element) {
              const animatedElementInActive = activeSlide.querySelector(".js-slide-text-item");
              if (animatedElementInActive) {
                animatedElementInActive.classList.add("animated");
              }
            } else {
              console.warn("activeSlide is not an Element:", activeSlide);
            }
          }, 300);
        },
      },
    });
  }

  // 複数の swiper をループで初期化
  const swiperClasses = [".mySwipe1"];
  swiperClasses.forEach((selector, index) => {
    initializeSwiper(selector, 0);
  });

  // フェードエフェクト付きの swiper
  // initializeSwiper(".mySwipeText", 1, "slide");

  var swiper = new Swiper(".mySwipeText", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    initialSlide: 1,
    speed: 1200,
    effect: "fade", // フェードエフェクト
    fadeEffect: {
      crossFade: true, // スライドが被らないようにする
    },
    on: {
      beforeInit: function () {
        $(".mySwipeText").css("opacity", "0"); // 初期状態で非表示
      },
      init: function (swiper) {
        setTimeout(() => {
          $(".mySwipeText").css("opacity", "1"); // 遅延後に表示
        }, 100); // 遅延させることで正しいスライドを表示
      },
      slideChangeTransitionStart: function () {
        let prevSlide = $(".mySwipeText .swiper-slide-prev");
        let activeSlide = $(".mySwipeText .swiper-slide-active");

        // 以前のスライドを SlideOut & FadeOut
        prevSlide.css({
          opacity: 1,
          transform: "translateY(0)",
          transition: "opacity 1s ease-out, transform 1s ease-out",
        });
        setTimeout(() => {
          prevSlide.css({
            opacity: 0,
            transform: "translateY(-40px)",
          });
        }, 100);

        // 新しいスライドを SlideIn & FadeIn
        activeSlide.css({
          opacity: 0,
          transform: "translateY(40px)",
          transition: "opacity 1s ease-out, transform 1s ease-out",
        });
        setTimeout(() => {
          activeSlide.css({
            opacity: 1,
            transform: "translateY(0)",
          });
        }, 600);
      },
    },
  });

  const $spMenuItems = $(".js-sp-menu .menu-item-has-children");

  // 親メニューのクリックでドロップダウンを制御
  $spMenuItems.each(function () {
    const $menuItem = $(this);
    const $link = $menuItem.find("> a"); // 直下のaタグを取得
    // $link.on("click", function (event) {
    //   event.preventDefault();
    // });
  });

  $spMenuItems.on("click", function (event) {
    if ($(event.target).is($spMenuItems.find(".c-dropdownBtn"))) {
      const $this = $(this);

      // メニューの開閉をトグル
      if ($this.hasClass("menu-open")) {
        $this.removeClass("menu-open");
      } else {
        $spMenuItems.removeClass("menu-open"); // 他のメニューを閉じる
        $this.addClass("menu-open"); // 現在のメニューを開く
      }
    }
  });

  const $menuItems = $(".js-header .menu-item-has-children");

  $menuItems.each(function () {
    const $menuItem = $(this);
    const $link = $menuItem.find("> a"); // 直下のaタグを取得
  });

  // メニューを開く処理
  $menuItems.on("mouseenter", function () {
    const $this = $(this);
    let enterTime = Date.now();
    $this.data("enter-time", enterTime);

    $menuItems.each(function () {
      clearTimeout($(this).data("open-timer"));
      clearTimeout($(this).data("close-timer"));
    });

    const otherMenuOpen = $menuItems.is(".menu-open");

    // 現在のメニューを開く
    // if (!otherMenuOpen) {

    $this.data(
      "open-timer",
      setTimeout(() => {
        const timeDiff = Date.now() - $this.data("enter-time");
        const isCurrentlyOpen = $this.hasClass("menu-open");
        const otherMenuOpen = $menuItems.is(".menu-open");

        if (Date.now() - $this.data("enter-time") >= 250) {
          $menuItems.not($this).removeClass("menu-open");
        }
        setTimeout(() => {
          if (Date.now() - $this.data("enter-time") >= 250) {
            if (!$this.hasClass("menu-open")) {
              $this.addClass("menu-open");
            }
          }
        }, 100);
      }, 300),
    );
  });

  // メニューを閉じる処理
  $menuItems.on("mouseleave", function (event) {
    const $relatedTarget = $(event.relatedTarget);
    const $this = $(this);
    let leadveTime = Date.now();
    $this.data("leave-time", leadveTime);

    // 閉じるタイマーを設定
    $this.data(
      "close-timer",
      setTimeout(() => {
        // if (Date.now() - $this.data("leave-time") >= 500) {
        $this.removeClass("menu-open");
        // }
      }, 500),
    );
  });

  // 子メニュー内にマウスが入ったら閉じるタイマーを解除
  $menuItems.find(".sub-menu").on("mouseenter", function () {
    const $parentItem = $(this).closest(".menu-item");
    clearTimeout($parentItem.data("close-timer"));
    clearTimeout($parentItem.data("open-timer"));
  });

  // メニュー外をクリックしたらすべてのメニューを閉じる
  $(document).on("click", function (event) {
    if (!$(event.target).closest(".menu").length) {
      $menuItems.removeClass("menu-open");
    }
  });
});
